import { render, staticRenderFns } from "./GenAIUsageTrendWidget.vue?vue&type=template&id=c53bb324&scoped=true&"
import script from "./GenAIUsageTrendWidget.vue?vue&type=script&lang=js&"
export * from "./GenAIUsageTrendWidget.vue?vue&type=script&lang=js&"
import style0 from "./GenAIUsageTrendWidget.vue?vue&type=style&index=0&id=c53bb324&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c53bb324",
  null
  
)

export default component.exports